import styled from '@emotion/styled'

export const Red = styled.span`
  color: red;
`
